"use client";
import { useCallback, useState } from "react";
//#region src/utils/use-controllable-state.ts
function useControllableState(props) {
	const { value, onChange, defaultValue } = props;
	const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
	const controlled = value !== void 0;
	return [controlled ? value : uncontrolledValue, useCallback((value) => {
		if (controlled) return onChange?.(value);
		setUncontrolledValue(value);
		return onChange?.(value);
	}, [controlled, onChange])];
}
//#endregion
export { useControllableState };
